import styled from "styled-components";

export const StyledDocumentsCounter = styled.div`
    margin-top: 10px;

    font-size: var(--size-14);
    color: var(--color-grey-900);
    line-height: 19px;
    svg {
        margin-right: 10px;
        vertical-align: text-bottom;
        width: 16px;
        height: 16px;
        path {
            fill: var(--color-secondary);
        }
    }
`;
